
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"80","height":"80","viewBox":"0 0 80 80","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M42.396 36.576c-.264-.233-.396-.591-.396-1.076 0-.601.162-1.066.487-1.396.264-.29.64-.436 1.127-.436.75 0 1.847.417 3.288 1.25C48.457 36 49.5 37 51.166 38.46 53.5 40 54 41.674 54 42.934c0 .581-.234 1.114-.7 1.6-.488.464-1.29.968-2.406 1.511-1.075.504-1.928.97-2.557 1.396-.548.388-1.532.911-2.953 1.57-1.42.66-2.283.989-2.588.989-.385 0-.781-.184-1.187-.553-.406-.387-.609-.775-.609-1.163 0-.484.162-.882.487-1.192.325-.31.984-.698 1.979-1.163 1.279-.62 2.243-1.154 2.892-1.6.71-.484 1.34-.852 1.888-1.104l.73-.379-.518-1.594C47.22 40.67 46.199 39.499 45 38.5c-1.2-1-2.3-1.691-2.604-1.924z"}}),_c('path',{attrs:{"d":"M27.15 40.585c-.1-.374-.15-.675-.15-.903 0-.769.312-1.277.935-1.526.262-.104.523-.156.785-.156.301 0 .925.093 1.87.28 1.469.29 13.225 1.786 15.156 1.89 1.448.083 2.363.166 2.745.249.362.062.674.218.936.467.382.373.573.851.573 1.432 0 .499-.15.904-.453 1.215a1.412 1.412 0 01-.724.405c-.281.041-.834.062-1.659.062-1.066 0-2.575-.114-4.526-.343-12.007-1.525-13.234-1.733-13.737-1.92-1.086-.415-1.67-.8-1.75-1.152z"}})])
          )
        }
      }
    